import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const login = async (email) => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        email: email,
    });

    localStorage.setItem("auth_t", email);
    return response;
};

export const logout = () => {
    localStorage.removeItem("auth_t");
};

export const isAuthenticated = () => {
    return !!localStorage.getItem("auth_t");
};

export const getToken = () => {
    return localStorage.getItem("auth_t");
};
